
<form>
    <div id="info" class="route-picker">
        <label>
            Interstate
            <select class="select" [(ngModel)]="interstate" name="interstate" id="interstate">
                <option *ngFor="let interstate of interstates" [ngValue]="interstate">I-{{ interstate }}</option>
            </select>
        </label>
    </div>
</form>
